setTimeout(function () {
  // Get all select boxes and search inputs
  var selectBoxes = document.querySelectorAll(".collection-select");
  var searchInputs = document.querySelectorAll("#My-Id");

  // Ensure there are select boxes and search inputs before continuing
  if (selectBoxes.length && searchInputs.length) {
    var searchValue = getUrlParameter("q");
    var selectedCategory = getUrlParameter("filter.p.product_type");

    // Loop through each search input and set its value
    searchInputs.forEach(function (searchInput) {
      if (searchValue) {
        searchInput.value = searchValue;
      }
    });

    // Loop through each select box and set its value
    selectBoxes.forEach(function (selectBox) {
      if (selectedCategory) {
        selectBox.value = selectedCategory;
      } else {
        selectBox.value = "all";
      }
    });
  }
}, 2000);

// Function to get URL parameter
function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

document.addEventListener("DOMContentLoaded", function () {
  // Attach event listeners to buttons after the DOM is fully loaded
  var buttons = document.querySelectorAll(".category-search-btn");
  var selectBox = document.querySelector(
    ".collection-select:not([style*='display: none'])"
  );
  var searchInput = document.getElementById("My-Id");

  buttons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Ensure selectBox and searchInput are found before proceeding
      if (selectBox && searchInput) {
        // Get the selected category and search input values
        var selectedValue = selectBox.value;
        var searchValue = searchInput.value;
        // Check if the search input is empty
        if (!searchValue.trim()) {
          alert("Please enter a search value before proceeding.");
          return;
        }
        // Construct the URL
        var baseURL = window.location.origin + "/search";
        var searchParam = "q=" + encodeURIComponent(searchValue);
        var optionsParam = "options%5Bprefix%5D=last";

        // Construct the full URL
        var fullURL = `${baseURL}?${searchParam}&${optionsParam}`;

        // Only add filter parameter if a value is selected and it's not the default value
        if (selectedValue && selectedValue !== "all") {
          fullURL += `&filter.p.product_type=${encodeURIComponent(
            selectedValue
          )}`;
        }
        // Redirect to the constructed URL
        window.location.href = fullURL;
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all select elements with the class 'collection-select'
  const selects = document.querySelectorAll(".collection-select");

  // Function to synchronize the selected value
  function synchronizeSelection(event) {
    const selectedValue = event.target.value;
    selects.forEach((select) => {
      if (select !== event.target) {
        select.value = selectedValue;
      }
    });
  }

  // Add change event listener to each select element
  selects.forEach((select) => {
    select.addEventListener("change", synchronizeSelection);
  });
});

// Function to handle code execution based on viewport width
function handleViewportWidth() {
  if (window.matchMedia("(max-width: 989px)").matches) {
    setTimeout(function () {
      var selectBoxes = document.querySelectorAll(
        ".mobile-search__form .collection-select"
      );
      var searchInputs = document.querySelectorAll(
        ".mobile-search__form .mobile-cat-search"
      );

      if (selectBoxes.length && searchInputs.length) {
        var searchValue = getUrlParameter("q");
        var selectedCategory = getUrlParameter("filter.p.product_type");

        searchInputs.forEach(function (searchInput) {
          if (searchValue) {
            searchInput.value = searchValue;
          }
        });

        selectBoxes.forEach(function (selectBox) {
          if (selectedCategory) {
            selectBox.value = selectedCategory;
          } else {
            selectBox.value = "all";
          }
        });
      }
    }, 2000);

    document.addEventListener("DOMContentLoaded", function () {
      // Handle drawer search button
      var drawerButton = document.querySelector(
        ".mobile-search__form .category-search-drawerbtn"
      );

      if (drawerButton) {
        drawerButton.addEventListener("click", function (e) {
          e.preventDefault();

          var selectBox = document.querySelector(
            ".mobile-search__form .collection-select:not([style*='display: none'])"
          );
          var searchInput = document.querySelector(
            ".mobile-search__form .mobile-cat-search"
          );

          if (selectBox && searchInput) {
            var selectedValue = selectBox.value;
            var searchValue = searchInput.value;

            // Check if the search input is empty
            if (!searchValue.trim()) {
              alert("Please enter a search value before proceeding.");
              return;
            }

            var baseURL = window.location.origin + "/search";
            var searchParam = "q=" + encodeURIComponent(searchValue);
            var optionsParam = "options%5Bprefix%5D=last";

            var fullURL = `${baseURL}?${searchParam}&${optionsParam}`;

            if (selectedValue && selectedValue !== "all") {
              fullURL += `&filter.p.product_type=${encodeURIComponent(
                selectedValue
              )}`;
            }

            // Redirect to the constructed URL
            window.location.href = fullURL;
          }
        });
      }

      // Handle header search button
      var headButton = document.querySelector(
        ".mobile-search__form .category-search-headbtn"
      );

      if (headButton) {
        headButton.addEventListener("click", function (e) {
          e.preventDefault();

          var selectBox = document.querySelector(
            ".mobile-search__form .collection-select:not([style*='display: none'])"
          );
          var searchInput = document.querySelector(
            ".menu-bar .mobile-search__form .mobile-cat-search"
          );

          if (selectBox && searchInput) {
            var selectedValue = selectBox.value;
            var searchValue = searchInput.value;

            // Check if the search input is empty
            if (!searchValue.trim()) {
              alert("Please enter a search value before proceeding.");
              return;
            }

            var baseURL = window.location.origin + "/search";
            var searchParam = "q=" + encodeURIComponent(searchValue);
            var optionsParam = "options%5Bprefix%5D=last";

            var fullURL = `${baseURL}?${searchParam}&${optionsParam}`;

            if (selectedValue && selectedValue !== "all") {
              fullURL += `&filter.p.product_type=${encodeURIComponent(
                selectedValue
              )}`;
            }

            // Redirect to the constructed URL
            window.location.href = fullURL;
          }
        });
      }
    });

    document.addEventListener("DOMContentLoaded", function () {
      const selects = document.querySelectorAll(".collection-select");

      function synchronizeSelection(event) {
        const selectedValue = event.target.value;
        selects.forEach((select) => {
          if (select !== event.target) {
            select.value = selectedValue;
          }
        });
      }

      selects.forEach((select) => {
        select.addEventListener("change", synchronizeSelection);
      });
    });
  }
}

handleViewportWidth();
window.addEventListener("resize", handleViewportWidth);
